export default function DETAIL_CARD_1(props) {
  return (
    <>
      {/* <div className="col-12 col-md-6 "> */}
      <div
        className="card service_card_1 "
        style={{ minHeight: `${props.minHeight}` }}
      >
        <div className="card-body  d-flex align-items-center justify-content-center">
          <div className="row ">
            <img
              src={props.image}
              className="service_card_image"
              alt="service"
            />

            <div className="mt-5 px-4 col-12 d-flex flex-column justify-content-center align-items-center text-center card_content">
              <h1
                className="fs-1 fw-light"
              >
                {props.title}
              </h1>
              <p
                className="service_card_desc mt-3 fs-4"
                style={{
                  textTransform: "capitalize",
                  lineHeight: "2.5rem",
                }}
              >
                {props.text}.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* </div/> */}
    </>
  );
}
